import React, { useRef, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useApp from "../../hooks/useApp";
import useApi from "../../hooks/useApi";

const ClientAccountView = () => {
  const [account, setAccount] = useState({});
  const nameRef = useRef();
  const pwdRef = useRef();
  const { id } = useParams();
  const { showAlert } = useApp();
  const navigate = useNavigate();

  const { api, abortSignal } = useApi();

  const handleSaveAccount = async (e) => {
    e.preventDefault();

    if (account.password !== account.confirmPassword) {
      showAlert("Password does not match", "error");
      pwdRef.current.focus();
    } else {
      try {
        const response = await api.openSave(`/auth/client-account`, {
          ...account,
          id: id,
        });
        if (response.ok) {
          showAlert(
            "Your user account has been updated.\n you will be redirected to the login page",
            "success"
          );

          navigate("/login", { replace: true });
        } else {
          showAlert(
            "Failed to upddate your user account.\n Please try again later",
            "error"
          );
        }
        //setAccount(data);
      } catch (error) {
        console.error(error);
      }
    }
    // console.log(account);
  };

  useEffect(() => {
    const callApi = async () => {
      try {
        const { data = {} } = await api.openRead(`/auth/client-account`, {
          id: id,
        });

        setAccount(data);
      } catch (error) {
        console.error(error);
      }
    };
    callApi();

    const abortApiCall = () => abortSignal && abortSignal.abort;
    return abortApiCall;
  }, [id]);

  useEffect(() => {
    if (!account?.status) {
      nameRef.current.focus();
    }
  }, [account]);

  switch (account?.status) {
    case "notfound":
      return <h1>Account not found. Please contact your administrator</h1>;
    // break;
    case "activated":
      return (
        <h1>
          Account already activated. Please <a href="/login">Login</a>
        </h1>
      );
    // break;
    default:
      return (
        <div className="card shadow-lg">
          <div className="card-body">
            <div className="text-center">
              <h1 className="h3">Client Account</h1>
              <p>Complete account creation process</p>
            </div>

            <form
              className="mt-4"
              onSubmit={handleSaveAccount}
              autoComplete="off"
            >
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={account?.email || ""}
                  readOnly
                />
              </div>
              <div className="mb-3">
                <input
                  ref={nameRef}
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  value={account?.name || ""}
                  onChange={(e) =>
                    setAccount({ ...account, name: e.target.value })
                  }
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  ref={pwdRef}
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={account?.password || ""}
                  onChange={(e) =>
                    setAccount({ ...account, password: e.target.value })
                  }
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Comfirm Passord"
                  value={account?.confirmPassword || ""}
                  onChange={(e) =>
                    setAccount({ ...account, confirmPassword: e.target.value })
                  }
                  required
                />
              </div>

              <div className="d-grid mt-5">
                <button className="btn btn-warning btn-lg" type="submit">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      );
  }
};

export default ClientAccountView;
